import { render } from "./MedicalRecordIcon.vue?vue&type=template&id=ef46d114"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__